<template>
  <v-layout justify-center>
    <v-layout
      v-if="loading"
      justify-center
      align-center
      style="height: 100vh; width: 100vw"
    >
      <v-progress-circular indeterminate color="blue"></v-progress-circular>
    </v-layout>
    <div v-else class="mt-8">
      <div class="font-weight-bold text-center mb-4" style="font-size: larger">
        契約書表示
      </div>
      <v-container class="d-flex justify-space-between">
        <div></div>
        <v-btn
          class="blue lighten-1"
          @click="dialog = true"
          :disabled="loadingPrint"
          :loading="loadingPrint"
        >
          印刷する
        </v-btn>
      </v-container>
      <v-container
        class="d-flex flex-column align-center"
        style="width: 100%; min-width: 700px"
      >
        <!-- Main PDF -->
        <div
          v-for="(pdf, pdfIndex) in pdfBytes"
          :key="'pdf-' + pdfIndex"
          class="pdf-column"
        >
          <div
            v-for="(page, pageIndex) in pdf.numPages"
            :key="'page-' + pageIndex"
          >
            <canvas
              class="page-break"
              :ref="'pdf-' + pdfIndex + '-page-' + pageIndex"
              :id="'pdf-' + pdfIndex + '-page-' + pageIndex"
            ></canvas>
          </div>
        </div>

        <!-- Rule PDF rotated -->
        <div
          v-for="(pdf, pdfIndex) in pdfBytesRule"
          :key="'rule-pdf-' + pdfIndex"
        >
          <div
            v-for="(page, pageIndex) in pdf.numPages"
            :key="'rule-page-' + pageIndex"
          >
            <canvas
              class="page-break"
              :ref="'rule-pdf-' + pdfIndex + '-page-' + pageIndex"
              :id="'rule-pdf-' + pdfIndex + '-page-' + pageIndex"
            ></canvas>
          </div>
        </div>
      </v-container>
    </div>

    <!-- Choose printed document -->
    <v-dialog width="460" v-model="dialog" persistent>
      <template>
        <v-card title="Dialog">
          <v-card-text class="pt-4 text-center">
            <v-checkbox v-model="isPrintRules" label="重要事項・概要書面" />
            <v-checkbox
              v-model="isPrintContract"
              class="mt-0"
              label="契約書書面"
            />
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn class="info" @click="handlePrint">印刷する</v-btn>
            <v-btn @click="handleCloseDialog">閉じる </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </v-layout>
</template>

<script>
import { PDFDocument } from "pdf-lib";

export default {
  name: "ContractDetail",

  data() {
    return {
      pdfBytes: [],
      pdfBytesRule: [],
      pdfLoaded: false,
      loading: false,
      loadingPrint: true,
      pdfDatas: [],
      dialog: false,
      isPrintRules: true,
      isPrintContract: true,
    };
  },

  created() {
    this.preventBackNavigation();
    this.courseId = this.$route.params.courseId;
    this.handleShow();
  },

  methods: {
    preventBackNavigation() {
      window.history.pushState(null, "", window.location.href);
      window.addEventListener("popstate", () => {
        window.history.pushState(null, "", window.location.href);
      });
    },

    async handleShow() {
      await this.loadPdf();
      await this.renderPdf();
    },

    async loadPdf() {
      this.loading = true;
      try {
        const pdfDatas = await Promise.all([
          this.getPdfData(`/api/v1/course-contract/${this.courseId}/company`),
          this.getPdfData(`/api/v1/course-contract/${this.courseId}/customer`),
          this.getPdfData(
            `/api/v1/course-contract/${this.courseId}/course-rule`
          ),
        ]);
        this.pdfDatas = pdfDatas;

        const pdfjsLib = window["pdfjs-dist/build/pdf"];
        pdfjsLib.GlobalWorkerOptions.workerSrc =
          "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.worker.min.js";

        this.pdfBytes = await Promise.all(
          pdfDatas.slice(0, 2).map(async (data) => {
            const pdf = await pdfjsLib.getDocument({ data }).promise;
            return { pdf, numPages: pdf.numPages };
          })
        );

        this.pdfBytesRule = [
          await pdfjsLib
            .getDocument({ data: pdfDatas[2] })
            .promise.then((pdf) => ({ pdf, numPages: pdf.numPages })),
        ];

        this.loading = false;
      } catch (error) {
        console.error("Error loading PDF data:", error);
      }
    },

    async getPdfData(url) {
      try {
        const response = await this.$axios.get(url, {
          responseType: "arraybuffer",
        });
        return response.data;
      } catch (error) {
        console.error(`Error fetching PDF from ${url}:`, error);
        throw error;
      }
    },

    async renderPdf() {
      if (!this.pdfBytes.length && !this.pdfBytesRule.length) return;

      const pdfjsLib = window["pdfjs-dist/build/pdf"];
      pdfjsLib.GlobalWorkerOptions.workerSrc =
        "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.worker.min.js";

      try {
        for (const [pdfIndex, { pdf, numPages }] of this.pdfBytes.entries()) {
          for (let pageIndex = 1; pageIndex <= numPages; pageIndex++) {
            const page = await pdf.getPage(pageIndex);
            const viewport = page.getViewport({ scale: 1.5 });

            const canvas =
              this.$refs["pdf-" + pdfIndex + "-page-" + (pageIndex - 1)][0];
            canvas.height = viewport.height;
            canvas.width = viewport.width;

            const context = canvas.getContext("2d");
            const renderContext = {
              canvasContext: context,
              viewport: viewport,
            };

            await page.render(renderContext).promise;
          }
        }

        for (const [
          pdfIndex,
          { pdf, numPages },
        ] of this.pdfBytesRule.entries()) {
          for (let pageIndex = 1; pageIndex <= numPages; pageIndex++) {
            const page = await pdf.getPage(pageIndex);
            const viewport = page.getViewport({ scale: 1.5 });

            const canvas =
              this.$refs[
                "rule-pdf-" + pdfIndex + "-page-" + (pageIndex - 1)
              ][0];
            canvas.height = viewport.width;
            canvas.width = viewport.height;

            const context = canvas.getContext("2d");
            context.translate(canvas.width / 2, canvas.height / 2);
            context.rotate((90 * Math.PI) / 180);
            context.translate(-canvas.height / 2, -canvas.width / 2);

            const renderContext = {
              canvasContext: context,
              viewport: page.getViewport({ scale: 1.5 }),
            };
            await page.render(renderContext).promise;
          }
        }

        this.pdfLoaded = true;
        this.loadingPrint = false;

        if (this.$route.query.isPrint) {
          this.isPrintContract = this.$route.query.isPrintContract;
          this.isPrintRules = this.$route.query.isPrintRules;
          await this.handlePrint();
        }
      } catch (error) {
        console.error("Error rendering PDF:", error);
      }
    },

    async contractPdf() {
      const pdfByte1 = this.pdfDatas[0];
      const pdfByte2 = this.pdfDatas[1];
      const pdfDoc1 = await PDFDocument.load(pdfByte1);
      const pdfDoc2 = await PDFDocument.load(pdfByte2);
      const [pdf2Page] = await pdfDoc1.copyPages(pdfDoc2, [0]);
      pdfDoc1.addPage(pdf2Page);
      pdfDoc1.setTitle("契約書");
      const pdfBytes = await pdfDoc1.save();
      return pdfBytes;
    },

    async printContractPdf() {
      const contractPdf = await this.contractPdf();
      const blob = new Blob([contractPdf], {
        type: "application/pdf",
      });
      const url = URL.createObjectURL(blob);
      const newWindow = window.open(url, "_blank");
      newWindow.onload = () => {
        setTimeout(() => {
          newWindow.print();
        }, 1000);
      };
      newWindow.onafterprint = () => {
        newWindow.close();
      };
    },

    async printRulesPdf() {
      const rulesPdf = this.pdfDatas[2];
      const rulesPdfDoc = await PDFDocument.load(rulesPdf);
      rulesPdfDoc.setTitle("重要事項・概要書面");
      const result = await rulesPdfDoc.save();
      const blob = new Blob([result], {
        type: "application/pdf",
      });
      const url = URL.createObjectURL(blob);
      const newWindow = window.open(url, "_blank");
      newWindow.onload = () => {
        setTimeout(() => {
          newWindow.print();
        }, 1000);
      };
      newWindow.onafterprint = () => {
        newWindow.close();
      };
    },

    async handlePrint() {
      if (!this.isPrintContract && !this.isPrintRules) {
        alert("印刷する書面を選択してください。");
      } else {
        this.dialog = false;
        if (this.pdfLoaded) {
          this.loadingPrint = true;
          this.isPrintRules && (await this.printRulesPdf());
          this.isPrintContract && (await this.printContractPdf());
          this.loadingPrint = false;
          this.handleCloseDialog();
        }
      }
    },

    handleCloseDialog() {
      this.dialog = false;
      this.isPrintContract = true;
      this.isPrintRules = true;
    },
  },
};
</script>

<style lang="css" scoped>
canvas {
  border: 1px solid black;
  display: none;
  width: 100%;
}

.page-break {
  page-break-inside: avoid !important;
}

#pdf-0-page-0 {
  display: block;
}

body {
  padding: 0;
  margin: 0;
  appearance: auto !important;
}

@media print {
  .v-btn,
  .font-weight-bold {
    display: none !important;
  }

  header,
  footer {
    display: none !important;
  }

  body {
    -webkit-print-color-adjust: exact !important; /*Chrome, Safari */
    print-color-adjust: exact;
    appearance: none !important;
  }

  .pdf-column {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  canvas {
    border: none;
    display: block;
  }

  @page {
    size: A4 portrait;
  }
}
</style>
